import React from 'react'
import { motion } from 'framer-motion'

const logos = [
  'Acme Corp',
  'Quantum',
  'Nexus',
  'Hyperglide',
  'Ember',
  'Starlight',
  'Vanguard',
]

const Trust: React.FC = () => {
  return (
    <section className='py-16 bg-[#0a0a0a] border-y border-[#1f1f1f] overflow-hidden'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center'>
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className='text-sm font-semibold text-slate-500 uppercase tracking-widest mb-8'
        >
          Trusted by 5,000+ forward-thinking teams
        </motion.p>

        {/* Infinite Logo Slider */}
        <div className='relative w-full overflow-hidden before:absolute before:inset-y-0 before:left-0 before:w-1/4 before:bg-gradient-to-r before:from-[#0a0a0a] before:to-transparent before:z-10 after:absolute after:inset-y-0 after:right-0 after:w-1/4 after:bg-gradient-to-l after:from-[#0a0a0a] after:to-transparent after:z-10 flex'>
          <motion.div
            animate={{ x: [0, -1035] }}
            transition={{
              ease: 'linear',
              duration: 25,
              repeat: Infinity,
            }}
            className='flex items-center gap-16 pr-16 whitespace-nowrap min-w-max'
          >
            {[...logos, ...logos, ...logos].map((logo, index) => (
              <div
                key={index}
                className='text-xl font-bold text-[#262626] font-sans tracking-wide select-none filter blur-[0.5px] hover:blur-none hover:text-slate-400 transition-all duration-300'
              >
                {logo}
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default Trust
